export enum MessageColor{
    success,
    error,
    warning
}